import axios from 'axios'
import camelize from 'camelize'
import {
  axiosInstanceConfig,
  interceptRequest,
  interceptResponseSucess,
  interceptResponseError
} from './config'

let activeRequests = 0

const showLoader = () => {
  document.dispatchEvent(
    new CustomEvent('global-loader', { detail: { loading: true } })
  )
}

const hideLoader = () => {
  document.dispatchEvent(
    new CustomEvent('global-loader', { detail: { loading: false } })
  )
}

const transformResponse = (data) => {
  try {
    if (data) {
      data = JSON.parse(data)
      data = camelize(data)
    }
  } catch (e) {
    // Keep unparsable data as is
  }
  return data
}

const axiosInstance = axios.create({
  ...axiosInstanceConfig,
  transformResponse
})

axiosInstance.interceptors.request.use(
  (config) => {
    if (config.load) {
      activeRequests++
      if (activeRequests === 1) {
        showLoader()
      }
    }
    return interceptRequest(config)
  },
  (error) => {
    activeRequests = Math.max(0, activeRequests - 1)
    if (activeRequests === 0) hideLoader()
    return Promise.reject(error)
  }
)

const EXCLUDED_ROUTES = ['profile', 'signup', 'login', 'otp', 'music', 'events']

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config.load) {
      activeRequests = Math.max(0, activeRequests - 1)
      if (activeRequests === 0) hideLoader()
    }
    return interceptResponseSucess(response)
  },
  (error) => {
    if (error?.config?.load) {
      activeRequests = Math.max(0, activeRequests - 1)
      if (activeRequests === 0) hideLoader()
    }
    const apiUrl = error?.config?.url || ''

    const shouldRedirect = !EXCLUDED_ROUTES.some((route) =>
      apiUrl.includes(route)
    )
    if (error?.response?.status === 401 && shouldRedirect) {
      window.location.href = '/signin'
      return Promise.reject(error)
    }
    return interceptResponseError(error)
  }
)

export default axiosInstance
